(function() {
    'use strict';

    angular.module('swif.publicLightning')
    .config(['$routeProvider', 'swifPublicLightningConstant', function($routeProvider, constants) {
        'ngInject';
        $routeProvider.when(constants.patrimoine.routes.referentiel, {
            templateUrl: 'partials/patrimoine/patrimoine_explorer_view.html',
            controller: 'PatrimoineReferentielController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifPublicLightningService', function (service) {
                    return service.patrimoine.resolveReferentielData();
                }]
            }
        });
        $routeProvider.when(constants.patrimoine.routes.controls, {
            templateUrl: 'partials/patrimoine/contracts_table_view.html',
            controller: 'PatrimoineContractsController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifPublicLightningService', function (service) {
                    return service.patrimoine.resolveContractsData();
                }]
            }
        });
    }]);
})();
